export default __webpack_public_path__ + "static/media/slider-img10.881c0c62.jpg";